/* eslint-disable i18next/no-literal-string */

/**
 * Ported verbatim from bouncieweb's `WrappedSVGs/TuroLogo.js`.
 *
 * The Turo wordmark on its dark plate. `backgroundColor` paints the plate,
 * `color` the wordmark itself.
 */
export default function TuroLogo({
  height = 74,
  width = 201,
  color = "#ffffff",
  backgroundColor = "#121214",
}: {
  height?: number;
  width?: number;
  color?: string;
  backgroundColor?: string;
}) {
  return (
    <svg
      version="1.2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 201 74"
      width={width}
      height={height}
      role="img"
      aria-label="Turo"
    >
      <path
        fill={backgroundColor}
        d="m177.3 7l-1.2-1.5c-0.4-0.5-0.8-1-1.2-1.4-2.5-2.3-5.7-3.6-9.2-3.6h-164.8v72.9h164.8c3.4 0.1 6.7-1.2 9.2-3.6 0.5-0.4 0.9-0.8 1.3-1.3 0-0.1 0-0.1 0-0.1l24.7-31.4z"
      />
      <path
        fill={color}
        d="m150.2 53.8c-9.5 0-16.9-7.3-16.9-16.7 0-8.8 7.6-16 17-16 4.5 0 8.8 1.7 12 4.7 3.2 3.1 5 7.3 4.9 11.7 0 9-7.6 16.3-17 16.3zm0-27.1c-3.1 0-6 1.1-8 3.1-2.1 1.9-3.3 4.7-3.3 7.8 0 2.9 1.2 5.5 3.5 7.5 2.1 1.9 5 3 7.9 3 3.1 0 5.9-1.1 8-3.1 2.1-2 3.3-4.8 3.3-7.8 0-2.9-1.2-5.6-3.3-7.6-2.2-1.8-5-2.9-8.1-2.9zm-76.9 27c-7.6 0-10.9-3.7-12-5.2-1.7-2.5-1.8-4.8-1.8-7.4v-19.1h5.6v19.1c0 2 0.2 3.5 1.5 4.9 1.4 1.4 3.8 2 7.3 2 2.9 0 4.8-0.4 6.1-1.4 1.3-1.1 1.9-2.9 1.9-5.5v-19.1h5.6v19.1c0 3-0.1 5.3-2.3 8-3 4-8.7 4.6-11.9 4.6zm46.7-0.6l-6.4-11.3h-10.3v11.2h-5.7v-31.1h18.6c6 0 10.2 4.1 10.2 10 0 4.6-2.6 8.2-6.7 9.5l6.7 11.6h-6.4zm-3.8-16.8c1.4 0 4.6-0.5 4.6-4.5 0-2.6-1.8-4.2-4.6-4.2h-12.9v8.7c0 0 12.9 0 12.9 0zm-81.9 16.8v-25.5h-10.9v-5.6h27.2v5.6h-10.8v25.5z"
      />
    </svg>
  );
}
